import { BrandBgEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandBgUnUseRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandBgUnUseRequestDTO.validationSchema(),
    BrandBgEntity
  );

  constructor(readonly data: RoomBrandBgUnUseRequest) {
    JsonSchemaValidator.assert(RoomBrandBgUnUseRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandBg"],
      properties: {
        roomId,
        brandBg: {
          instanceof: BrandBgEntity.name
        }
      }
    };
  }
}

interface RoomBrandBgUnUseRequest {
  roomId: RoomId;
  brandBg: BrandBgEntity;
}
